import React, { useEffect, useState, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { Modal } from 'rsuite'
import Select from 'react-select'
import { toast } from '../../CommonComponents/ToastComponent/toast'
import { getChildSuppliers, getChildSuppliersByUserCount, getLocationBasedMasterSuppliers, getMasterSuppliers, getMasterSuppliersByUserCount } from '../../../redux/actions/vendor'
import { Table } from 'rsuite'
import LoaderComponent from '../../CommonComponents/LoaderComponent'
import StickyHeader from './sticky-header'
import 'react-phone-input-2/lib/style.css'
import SupplierInfoModal from './supplier-info-modal'
const { Column, HeaderCell, Cell, Pagination } = Table

export const LinkCell = ({ rowData, dataKey, onClick, ...props }) => {
    let bgColorClass = dataKey === 'supplierQARole' ? rowData[dataKey].toLowerCase() === 'approved' ? 'bg-green' : rowData[dataKey].toLowerCase() === 'rejected' ? 'bg-red' : 'bg-yellow' : ''
    let textClass = dataKey === 'supplierQARole' ? 'text-white h5 btn' : 'text-black'
    let globalAcceptance = 'N/A'

    if (dataKey === 'acceptanceType') {
        if (!rowData?.isMaster && rowData?.masterId) {
            if (!rowData?.masterCardAcc) {
                globalAcceptance = 'N/A'
            } else {
                const { isAcceptGlobalAcceptance } = rowData?.masterCardAcc
                globalAcceptance = isAcceptGlobalAcceptance ? "Global" : isAcceptGlobalAcceptance === false ? "Location" : "N/A"
            }
        } else {
            if (!rowData?.cardAcceptance) {
                globalAcceptance = 'N/A'
            } else {
                const { isAcceptGlobalAcceptance } = rowData?.cardAcceptance
                globalAcceptance = isAcceptGlobalAcceptance ? "Global" : isAcceptGlobalAcceptance === false ? "Location" : "N/A"
            }
        }
        return (
            <Cell {...props} className="table-link" title={globalAcceptance}>
                {globalAcceptance}
            </Cell>
        )
    }

    if (dataKey === 'acceptsCard') {
        let isAcceptCard = 'N/A'
        if (!rowData?.isMaster && rowData?.masterId) {
            if (!rowData?.masterCardAcc) {
                isAcceptCard = 'N/A'
            } else {
                const { isAcceptAmericanExpress, isAcceptMasterCard, isAcceptVisa } = rowData?.masterCardAcc
                if (isAcceptAmericanExpress || isAcceptMasterCard || isAcceptVisa) {
                    isAcceptCard = "Yes"
                } else if (isAcceptAmericanExpress === false && isAcceptMasterCard === false && isAcceptVisa === false) {
                    isAcceptCard = "No"
                }
            }
        } else {
            if (!rowData?.cardAcceptance) {
                isAcceptCard = 'N/A'
            } else {
                const { isAcceptAmericanExpress, isAcceptMasterCard, isAcceptVisa } = rowData?.cardAcceptance
                if (isAcceptAmericanExpress || isAcceptMasterCard || isAcceptVisa) {
                    isAcceptCard = "Yes"
                } else if (isAcceptAmericanExpress === false && isAcceptMasterCard === false && isAcceptVisa === false) {
                    isAcceptCard = "No"
                }
            }
        }

        return (
            <Cell {...props} className="table-link" title={isAcceptCard}>
                {isAcceptCard}
            </Cell>
        )
    }

    return (
        <Cell {...props} className="table-link" title={rowData[dataKey]}>
            <button type="button" style={{ width: '60px' }} className={`rounded ${textClass} mb-0 ${bgColorClass}`} onClick={() => dataKey !== 'supplierQARole' && onClick(rowData.id)}>
                {rowData[dataKey]}
            </button>
        </Cell>
    )
}

export const SelectorCell = ({ rowData, dataKey, onChange, selectedSupplierId, onSelectSupplier, ...props }) => {
    const isSelected = selectedSupplierId ? selectedSupplierId === rowData.id : false
    return (
        <Cell {...props} className="table-action" fixed>
            <div className="button container text-center p-0">
                {
                    !rowData?.isMaster && !rowData?.masterId
                        ?
                        <button type="button" className="btn text-white shadow-none bg-gray w-100 h-100" disabled>No Master</button>
                        : (isSelected ? (
                            <button type="button" className="btn text-white w-100 h-100  bg-gray shadow-none select" onClick={() => onSelectSupplier(null)}>Un-select</button>
                        ) : (
                            <button type="button" className={`btn btn-green w-100 h-100 shadow-none select`} onClick={() => onSelectSupplier(rowData)}>Select</button>
                        ))
                }
            </div>
        </Cell>
    )
}

const SearchModal = ({ show, onGoBack, selectedVendor, onConfirm, isLoading, setShowCreateMasterModal, isFromRelatedSuppliers = false, showSearchModal = false, contactsData = [] }) => {
    const searchColumns = [
        { name: 'suppliername', label: 'Name' },
        { name: 'address', label: 'Address' },
        { name: 'city', label: 'City' },
        { name: 'state', label: 'State' },
        { name: 'zip', label: 'Zip' },
        { name: 'phone', label: 'Phone Number' },
        { name: 'email', label: 'Email' }
    ]

    const searchOptions = [
        { label: 'All', value: 'all' },
        { label: 'Master Suppliers', value: 'master' },
        { label: 'Location Bases Master Suppliers', value: 'location' }
    ]

    if (!isFromRelatedSuppliers) {
        searchOptions.push({ label: 'Child Suppliers', value: 'child' })
    }

    const supplierColumns = [
        { name: 'supplierQARole', label: 'QA Status' },
        { name: 'suppliername', label: 'Supplier Name' },
        { name: 'address1', label: 'Address 1' },
        { name: 'address2', label: 'Address 2' },
        { name: 'city', label: 'City' },
        { name: 'abbreviatedState', label: 'State' },
        { name: 'zip', label: 'Zip' },
        // { name: 'phone', label: 'Phone No' },
        { name: 'email', label: 'Email' },
        { name: 'acceptanceType', label: 'Acceptance Type' },
        { name: 'acceptsCard', label: 'Accepts Card' }


    ]

    const locationSupplierColumns = [
        { name: 'supplierQARole', label: 'QA Status' },
        { name: 'suppliername', label: 'Location Master Supplier' },
        { name: 'primaryMasterSupplierName', label: 'Primary Master Supplier Name' },
        { name: 'address1', label: 'Address 1' },
        { name: 'address2', label: 'Address 2' },
        { name: 'city', label: 'City' },
        { name: 'abbreviatedState', label: 'State' },
        { name: 'zip', label: 'Zip' },
        { name: 'email', label: 'Email' },
        { name: 'acceptanceType', label: 'Acceptance Type' },
        { name: 'acceptsCard', label: 'Accepts Card' }
    ]

    const dispatch = useDispatch()
    const [searchTarget, setSearchTarget] = useState(searchOptions[0])
    const [searchList, setSearchList] = useState({})
    const [lookupTableData, setLookupTableData] = useState([])
    const [masterTableData, setMasterTableData] = useState([])
    const [totalRecords, setTotalRecords] = useState(0)
    const [totalMasterRecords, setTotalMasterRecords] = useState(0)
    const [locationBasedMastersTableData, setLocationBasedMastersTableData] = useState([])
    const [totalLocationMasterRecords, setTotalLocationMasterRecords] = useState(0)
    const [isSearching, setIsSearching] = useState(false)
    const [childLimit, setChildLimit] = useState(10)
    const [childPage, setChildPage] = useState(1)
    const [masterLimit, setMasterLimit] = useState(10)
    const [masterPage, setMasterPage] = useState(1)
    const [locationMasterLimit, setLocationMasterLimit] = useState(10)
    const [locationMasterPage, setLocationMasterPage] = useState(1)
    const [isLoadingMaster, setIsLoadingMaster] = useState(false)
    const [isLoadingChild, setIsLoadingChild] = useState(false)
    const [isLoadingLocationMaster, setIsLoadingLocationMaster] = useState(false)
    const [noResultText, setNoResultText] = useState('')
    const [showSupplierInfoModal, setShowSupplierInfoModal] = useState(false)
    const [selectedSupplierData, setSelectedSupplierData] = useState([])
    const [selectedSupplierId, setSelectedSupplierId] = useState(null)
    const [masterSupplierId, setMasterSupplierId] = useState(null)
    const [selectedSupplierName, setSelectedSupplierName] = useState(null)
    const [isSearchDataIsNull, setIsSearchDataIsNull] = useState(false)
    const [onClear, setOnClear] = useState(false)

    const testref = useRef();
    const handleChangeSearchOption = (searchOption) => {
        setSearchTarget(searchOption)
    }

    const handleChangeSearch = (searchKey, colName) => {
        const tmpSearchList = { ...searchList }
        tmpSearchList[colName] = searchKey
        setSearchList(tmpSearchList)
    }

    const handleClickSearch = async () => {
        setOnClear(false)
        setSelectedSupplierId(null)
        setMasterSupplierId(null)
        setSelectedSupplierName(null)
        let tmpSearchList = { ...searchList }
        Object.keys(tmpSearchList).forEach((key) => (!tmpSearchList[key] || tmpSearchList[key] === null || tmpSearchList[key] === '') && delete tmpSearchList[key]);
        if (Object.keys(searchList).length === 0 || Object.keys(tmpSearchList).length === 0) {
            toast.show({
                title: 'Warning',
                description: 'Please fill one of the search options!'
            })
            return
        }
        if (searchTarget.value === 'all') {
            setIsSearching(true)
            if (!isFromRelatedSuppliers) {
                await getChildSuppliersData(searchList, true)
            }
            await getMasterSuppliersData(searchList)
            await getLocationBasedSuppliersData(searchList)
            setIsSearching(false)
        } else if (searchTarget.value === 'child' && !isFromRelatedSuppliers) {
            setIsSearching(true)
            await getChildSuppliersData(searchList, true)
            setMasterTableData([])
            setTotalMasterRecords(0)
            setLocationBasedMastersTableData([])
            setTotalLocationMasterRecords(0)
            setIsSearching(false)
        } else if (searchTarget.value === 'master') {
            setIsSearching(true)
            await getMasterSuppliersData(searchList)
            setLookupTableData([])
            setTotalRecords(0)
            setLocationBasedMastersTableData([])
            setTotalLocationMasterRecords(0)
            setIsSearching(false)
        } else if (searchTarget.value === 'location') {
            setIsSearching(true)
            await getLocationBasedSuppliersData(searchList)
            setMasterTableData([])
            setTotalMasterRecords(0)
            setLookupTableData([])
            setTotalRecords(0)
            setIsSearching(false)
        }
    }

    const handleClickClearSearch = () => {
        setIsSearchDataIsNull(false)
        setOnClear(true)
        setSearchList({})
        setSearchTarget(searchOptions[0])
        setMasterTableData([])
        setLookupTableData([])
        setLocationBasedMastersTableData([])
        setTotalRecords(0)
        setTotalMasterRecords(0)
        setTotalLocationMasterRecords(0)
        setSelectedSupplierId(null)
        setMasterSupplierId(null)
        setSelectedSupplierName(null)
        setNoResultText('')
    }

    const getChildSuppliersData = async (searchList = {}, isMasterDetailsRequired = false) => {
        await dispatch(getChildSuppliers({
            limit: 10,
            offset: 0,
            searchList,
            noMaster: false,
            hasMaster: true,
            isMasterDetailsRequired
        })).then(async (res) => {
            if (res?.childSuppliers?.length === 0) {
                setIsSearchDataIsNull(true)
            } else {
                setIsSearchDataIsNull(false)
            }
            setLookupTableData(res?.childSuppliers || [])
            setTotalRecords(res?.totalChilds || 0)
        }).catch(() => {
            setIsSearching(false)
            setIsSearchDataIsNull(false)
        })
    }

    const getLocationBasedSuppliersData = async (searchList = {}) => {
        await dispatch(getLocationBasedMasterSuppliers({
            limit: 10,
            offset: 0,
            searchList,
        })).then(async (res) => {
            if (res?.locationMasters?.length === 0) {
                setIsSearchDataIsNull(true)
            } else {
                setIsSearchDataIsNull(false)
            }
            setLocationBasedMastersTableData(res?.locationMasters || [])
            setTotalLocationMasterRecords(res?.totalLocationMasters || 0)
        }).catch(() => {
            setIsSearching(false)
            setIsSearchDataIsNull(false)
        })
    }

    const getMasterSuppliersData = async (searchList = {}) => {
        await dispatch(getMasterSuppliers({
            limit: 10,
            offset: 0,
            searchList
        })).then(async (masterRes) => {
            if (masterRes?.masterSuppliers.length === 0) {
                setIsSearchDataIsNull(true)
                setIsSearchDataIsNull(false)
            } else {
            }
            setMasterTableData(masterRes?.masterSuppliers)
            setTotalMasterRecords(masterRes?.totalMasters || 0)
        }).catch(() => {
            setIsSearching(false)
            setIsSearchDataIsNull(false)
        })
    }

    const handleClickSupName = async (supType, supID) => {
        let data = supType === 'master' ? masterTableData.find(sup => supID === sup.id) : supType === 'location' ? locationBasedMastersTableData?.find(sup => supID === sup.id) : lookupTableData.find(sup => supID === sup.id)
        setSelectedSupplierData(data)
        setShowSupplierInfoModal(true)
    }

    const headerElements = (supType) => supplierColumns.map((h, index) => {
        if (index === 0 || index === 1) {
            return (
                <Column
                    width={index === 0 ? 80 : 120}
                    resizable
                    sortable
                    key={h.name}
                >
                    <HeaderCell className='text-black fw-bold'>{h.label}</HeaderCell>
                    <LinkCell dataKey={h.name} onClick={(supId) => { index === 1 && handleClickSupName(supType, supId) }} />
                </Column>
            )
        }

        if (h.name === "acceptanceType") {
            return (
                <Column
                    width={index === 0 ? 80 : 120}
                    resizable
                    sortable
                    key={h.name}
                >
                    <HeaderCell className='text-black fw-bold'>{h.label}</HeaderCell>
                    <LinkCell dataKey={h.name} />
                </Column>
            )
        }

        if (h.name === "acceptsCard") {
            return (
                <Column
                    width={index === 0 ? 80 : 120}
                    resizable
                    sortable
                    key={h.name}
                >
                    <HeaderCell className='text-black fw-bold'>{h.label}</HeaderCell>
                    <LinkCell dataKey={h.name} />
                </Column>
            )
        }
        return (
            <Column
                width={h.name === 'abbreviatedState' ? 60 : h.name === 'zip' ? 80 : 100}
                resizable
                sortable
                key={h.name}
            >
                <HeaderCell className='text-black fw-bold'>{h.label}</HeaderCell>
                <Cell dataKey={h.name} >
                    {rowData => {
                        return <p title={rowData?.[h.name] || ''}>{rowData?.[h.name] || ''}</p>
                    }}
                </Cell>
            </Column>
        )
    })

    const headerElementsForLocationBased = () => locationSupplierColumns.map((h, index) => {
        if (index === 0 || index === 1) {
            return (
                <Column
                    width={index === 0 ? 80 : 120}
                    resizable
                    sortable
                    key={h.name}
                >
                    <HeaderCell className='text-black fw-bold'>{h.label}</HeaderCell>
                    <LinkCell dataKey={h.name} onClick={(supId) => { index === 1 && handleClickSupName('location', supId) }} />
                </Column>
            )
        }

        if (h.name === "acceptanceType") {
            return (
                <Column
                    width={index === 0 ? 80 : 120}
                    resizable
                    sortable
                    key={h.name}
                >
                    <HeaderCell className='text-black fw-bold'>{h.label}</HeaderCell>
                    <LinkCell dataKey={h.name} />
                </Column>
            )
        }

        if (h.name === "acceptsCard") {
            return (
                <Column
                    width={index === 0 ? 80 : 120}
                    resizable
                    sortable
                    key={h.name}
                >
                    <HeaderCell className='text-black fw-bold'>{h.label}</HeaderCell>
                    <LinkCell dataKey={h.name} />
                </Column>
            )
        }
        return (
            <Column
                width={h.name === 'abbreviatedState' ? 60 : h.name === 'zip' ? 80 : 100}
                resizable
                sortable
                key={h.name}
            >
                <HeaderCell className='text-black fw-bold'>{h.label}</HeaderCell>
                <Cell dataKey={h.name} >
                    {rowData => {
                        return <p title={rowData?.[h.name] || ''}>{rowData?.[h.name] || ''}</p>
                    }}
                </Cell>
            </Column>
        )
    })

    const handleChangeLimit = (limit, supType) => {
        supType === 'master' ? setMasterPage(1) : supType === 'location' ? setLocationMasterPage(1) : setChildPage(1);
        supType === 'master' ? setMasterLimit(limit) : supType === 'location' ? setLocationMasterLimit(limit) : setChildLimit(limit);
    }

    const handleChangePage = async (event, supType) => {
        if (supType === 'child' && !isFromRelatedSuppliers) {
            setChildPage(event)
            setIsLoadingChild(true)
            dispatch(getChildSuppliers({
                limit: childLimit,
                offset: childLimit * (event - 1),
                searchList,
                noMaster: false,
                hasMaster: false
            })).then(res => {
                setIsLoadingChild(false)
                setLookupTableData(res?.childSuppliers)
            }).catch(() => {
                setLookupTableData([])
                setIsLoadingChild(false)
            })
        } else if (supType === 'location') {
            setLocationMasterPage(event)
            setIsLoadingLocationMaster(true)
            await dispatch(getLocationBasedMasterSuppliers({
                limit: locationMasterLimit,
                offset: locationMasterLimit * (event - 1),
                searchList,
            })).then(async (res) => {
                setLocationBasedMastersTableData(res?.locationMasters)
                setIsLoadingLocationMaster(false)
            }).catch(() => {
                setLocationBasedMastersTableData([])
                setTotalLocationMasterRecords(0)
                setIsLoadingLocationMaster(false)
            })
        } else {
            setMasterPage(event)
            setIsLoadingMaster(true)
            dispatch(getMasterSuppliers({
                limit: masterLimit,
                offset: masterLimit * (event - 1),
                searchList
            })).then(masterRes => {
                setIsLoadingMaster(false)
                setMasterTableData(masterRes?.masterSuppliers)
            }).catch(() => {
                setMasterTableData([])
                setIsLoadingMaster(false)
            })
        }
    }

    useEffect(() => {
        if (isSearching === false && Object.keys(searchList).length > 0 && totalMasterRecords === 0 && totalRecords === 0 && totalLocationMasterRecords === 0) {
            setNoResultText('No search result found.')
        } else {
            setNoResultText('')
        }
    }, [!isSearching])

    const handleSelectSupplier = (rowData, supType) => {
        setSelectedSupplierId(rowData && rowData?.id ? rowData?.id : null)
        setMasterSupplierId(rowData && rowData?.id ? (rowData?.isMaster ? rowData?.id : rowData?.masterId) : null)
        setSelectedSupplierName(rowData && rowData?.suppliername ? rowData?.suppliername : null)
    }

    const handleKeyDown = (e) => {
        if (e.which === 13) {
            handleClickSearch()
        }
    }

    const handleConfirmClick = (supplierIdToMatch, status, masterSupplierId) => {
        if (!supplierIdToMatch) {
            toast.show({
                title: 'Warning',
                description: 'Please select the supplier!'
            })
            return
        }
        if (!masterSupplierId) {
            toast.show({
                title: 'Warning',
                description: 'The selected supplier not assigned to any master supplier!'
            })
            return
        }

        setShowSupplierInfoModal(false)
        onConfirm(showSearchModal ? selectedVendor : selectedVendor?.id, supplierIdToMatch, status, null, masterSupplierId)
    }

    const handleCancelClick = () => {
        setSelectedSupplierId(null)
        setMasterSupplierId(null)
        setSelectedSupplierName(null)
        onGoBack()
    }

    return (
        <div>
            <Modal
                backdrop='static'
                className="qa-list-modal"
                show={show}
                size="lg"
                onClick={() => { onGoBack() }}
                onHide={() => { onGoBack() }}
            >
                <Modal.Header>
                    <Modal.Title>
                        <h3 className='mb-0 text-black fw-bold'> Search for Supplier to Match </h3>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className={`mt-4 ${(isSearching || isLoading) ? 'loading' : ''}`}>
                    {!showSearchModal && <StickyHeader vendorDetails={selectedVendor} searchList={searchList} setSearchList={setSearchList} setOnClear={setOnClear} copyBtn={true} contactsData={contactsData} />}
                    {(isSearching || isLoading) && <LoaderComponent />}
                    <div className='d-flex border rounded p-4 mt-5'>
                        <div className="search-input-container d-flex gap-3 flex-wrap w-75">
                            {
                                searchColumns.map(column => {
                                    return (
                                        <div className="search-input-item" key={column.label}>
                                            <input
                                                type="text"
                                                value={onClear ? '' : (column.name === "address" ? searchList['address1'] : searchList[column.name] !== "" ? searchList[column.name] : "")}
                                                className="search-input h5 mb-0"
                                                placeholder={column.label}
                                                onChange={(e) => { handleChangeSearch(e.target.value, column.name) }}
                                                onKeyDown={handleKeyDown}
                                            />
                                        </div>
                                    )
                                })
                            }
                        </div>
                        <div className="search-action flex-grow-1">
                            <div className="option-selector h4 mb-3">
                                <Select
                                    value={searchTarget}
                                    options={searchOptions}
                                    className="select-searchoption"
                                    onChange={handleChangeSearchOption}
                                    onKeyDown={handleKeyDown}
                                />
                            </div>
                            <div className="button-group">
                                <button type="button" className="bg-green rounded search me-4 p-4 pt-2 pb-2 text-white h4 mb-0" onClick={handleClickSearch} disabled={(isSearching || isLoading)}>
                                    Search
                                </button>
                                <button type="button" className="bg-gray rounded clear p-4 pt-2 pb-2 text-white h4 mb-0" onClick={handleClickClearSearch} disabled={(isSearching || isLoading)}>
                                    Clear
                                </button>
                            </div>
                        </div>
                    </div>
                    {masterTableData.length > 0 && (
                        <div className={`list-table mt-5 position-relative ${isLoadingMaster && 'loading'}`}>
                            {isLoadingMaster && <LoaderComponent />}
                            <h2 className='mb-0 fw-bold'>Master Supplier Records</h2>
                            <div className='mt-4 border border-2 rounded'>
                                <Table
                                    virtualized={true}
                                    autoHeight
                                    affixHeader={true}
                                    data={masterTableData}
                                >
                                    {headerElements('master')}
                                    <Column
                                        width={70}
                                        fixed="right"
                                        key="action"
                                    >
                                        <HeaderCell className='text-black fw-bold text-center'>Action</HeaderCell>
                                        <SelectorCell
                                            onSelectSupplier={(id) => { handleSelectSupplier(id, 'master') }}
                                            selectedSupplierId={selectedSupplierId}
                                        />
                                    </Column>
                                </Table>
                                <div className="child-vendor-table-pagination">
                                    <Pagination
                                        prev
                                        next
                                        first={false}
                                        last={false}
                                        showInfo
                                        maxButtons={5}
                                        activePage={masterPage}
                                        displayLength={masterLimit}
                                        lengthMenu={[
                                            {
                                                label: '10',
                                                value: 10,
                                            },
                                            {
                                                label: '20',
                                                value: 20,
                                            },
                                            {
                                                label: '30',
                                                value: 30,
                                            },
                                            {
                                                label: '50',
                                                value: 50,
                                            },
                                            {
                                                label: '100',
                                                value: 100,
                                            },
                                        ]}
                                        total={totalMasterRecords}
                                        onChangeLength={(limit) => { handleChangeLimit(limit, 'master') }}
                                        onChangePage={(event) => { handleChangePage(event, 'master') }}
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                    {(!showSearchModal && lookupTableData.length > 0) && (
                        <div className={`list-table mt-5 position-relative ${isLoadingChild && 'loading'}`}>
                            {isLoadingChild && <LoaderComponent />}
                            <h2 className='mb-0 fw-bold'>Child Supplier Records</h2>
                            <div className='mt-4 border border-2 rounded'>
                                <Table
                                    virtualized={true}
                                    autoHeight
                                    affixHeader={true}
                                    data={lookupTableData}
                                >
                                    {headerElements('child')}
                                    <Column
                                        width={70}
                                        fixed="right"
                                        key="action"
                                    >
                                        <HeaderCell className='text-black fw-bold text-center'>Action</HeaderCell>
                                        <SelectorCell
                                            onSelectSupplier={(id) => { handleSelectSupplier(id, 'child') }}
                                            selectedSupplierId={selectedSupplierId}
                                        />
                                    </Column>
                                </Table>
                                <div className="child-vendor-table-pagination">
                                    <Pagination
                                        prev
                                        next
                                        first={false}
                                        last={false}
                                        showInfo
                                        maxButtons={5}
                                        activePage={childPage}
                                        displayLength={childLimit}
                                        lengthMenu={[
                                            {
                                                label: '10',
                                                value: 10,
                                            },
                                            {
                                                label: '20',
                                                value: 20,
                                            },
                                            {
                                                label: '30',
                                                value: 30,
                                            },
                                            {
                                                label: '50',
                                                value: 50,
                                            },
                                            {
                                                label: '100',
                                                value: 100,
                                            },
                                        ]}
                                        total={totalRecords}
                                        onChangeLength={(limit) => { handleChangeLimit(limit, 'child') }}
                                        onChangePage={(event) => { handleChangePage(event, 'child') }}
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                    {locationBasedMastersTableData.length > 0 && (
                        <div className={`list-table mt-5 position-relative ${isLoadingLocationMaster && 'loading'}`}>
                            {isLoadingLocationMaster && <LoaderComponent />}
                            <h2 className='mb-0 fw-bold'>Location Based Master Supplier Records</h2>
                            <div className='mt-4 border border-2 rounded'>
                                <Table
                                    virtualized={true}
                                    autoHeight
                                    affixHeader={true}
                                    data={locationBasedMastersTableData}
                                >
                                    {headerElementsForLocationBased()}
                                    <Column
                                        width={100}
                                        fixed="right"
                                        key="action"
                                    >
                                        <HeaderCell className='text-black fw-bold text-center'>Action</HeaderCell>
                                        <SelectorCell
                                            onSelectSupplier={(id) => { handleSelectSupplier(id, 'locationBasedSupplier') }}
                                            selectedSupplierId={selectedSupplierId}
                                        />
                                    </Column>
                                </Table>
                                <div className="location-master-vendor-table-pagination">
                                    <Pagination
                                        prev
                                        next
                                        first={false}
                                        last={false}
                                        showInfo
                                        maxButtons={5}
                                        activePage={locationMasterPage}
                                        displayLength={locationMasterLimit}
                                        lengthMenu={[
                                            {
                                                label: '10',
                                                value: 10,
                                            },
                                            {
                                                label: '20',
                                                value: 20,
                                            },
                                            {
                                                label: '30',
                                                value: 30,
                                            },
                                            {
                                                label: '50',
                                                value: 50,
                                            },
                                            {
                                                label: '100',
                                                value: 100,
                                            },
                                        ]}
                                        total={totalLocationMasterRecords}
                                        onChangeLength={(limit) => { handleChangeLimit(limit, 'location') }}
                                        onChangePage={(event) => { handleChangePage(event, 'location') }}
                                    />
                                </div>
                            </div>
                        </div>
                    )}

                    <div className='my-3'>
                        {(isSearchDataIsNull && lookupTableData?.length === 0 && masterTableData?.length === 0 && locationBasedMastersTableData?.length === 0) && (
                            <h3 className='mt-4 fw-bold mb-0'> {noResultText}</h3>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="bg-blue rounded search p-4 pt-2 pb-2 text-white h4 mb-0 my-2" onClick={() => setShowCreateMasterModal(true)} disabled={isSearching || isLoading} >
                        Create Master Supply
                    </button>
                    {(masterTableData?.length > 0 || lookupTableData?.length > 0 || locationBasedMastersTableData?.length > 0) && (
                        <>
                            <button
                                type="button"
                                className="bg-gray rounded ms-4 me-4 clear p-4 pt-2 pb-2 text-white h4 mb-0"
                                onClick={handleCancelClick}
                                disabled={isSearching || isLoading}
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="bg-green rounded search p-4 pt-2 pb-2 text-white h4 mb-0"
                                onClick={() => handleConfirmClick(selectedSupplierId, 'Manually Matched Master', masterSupplierId)}
                                disabled={isSearching || isLoading}
                            >
                                Confirm
                            </button>
                        </>
                    )}
                </Modal.Footer>
            </Modal>
            {showSupplierInfoModal && (
                <SupplierInfoModal
                    supplierData={selectedSupplierData}
                    show={showSupplierInfoModal}
                    onClose={() => { setShowSupplierInfoModal(false); setSelectedSupplierData([]) }}
                    selectedVendor={selectedVendor}
                    onConfirm={handleConfirmClick}
                />
            )}
        </div>
    )
}

export default SearchModal